import { createSelector } from '@reduxjs/toolkit';

import { initialState } from './slice';

// First select the relevant part from the state
const selectDomain = state => state.companyUser || initialState;

export const selectCompanyDetails = createSelector(
  [selectDomain],
  state => state.companyDetails,
);
